import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/organizations',
    name: 'organizationsList',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organizationsList" */ './views/organizations-list.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/organization/:organizationId',
    name: 'organization',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization" */ './views/organization.vue'
        )
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.organizationId = parseInt(
          routeTo.params.organizationId
        )
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('organizations/fetchStatusUpdates', {
              organizationId: routeTo.params.organizationId,
            }),
            store.dispatch('organizations/fetchOrganization', {
              organizationId: routeTo.params.organizationId,
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Organization' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      organizationId: parseInt(route.meta.tmp.organizationId, 10),
    }),
  },
  {
    path: '/organization/:organizationId/events',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organizationEvents" */ './views/events-organization.vue'
        )
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.organizationId = parseInt(
          routeTo.params.organizationId
        )
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('organizations/fetchOrganization', {
              organizationId: routeTo.params.organizationId,
            }),
            store.dispatch('events/fetchFilteredEvents', {
              coHostOrganizationId: parseInt(routeTo.params.organizationId),
              filters: {},
            }),
            store.dispatch('events/fetchGroupsHierarchy'),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Organization' } })
            })
        }
      },
    },
    props: (route) => ({
      organizationId: parseInt(route.meta.tmp.organizationId, 10),
    }),
    children: [
      {
        path: '',
        name: 'organizationEvents',
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "organizationEventsTab" */ './views/subviews/events-organization-tab.vue'
            )
          ),
        props: (route) => ({
          organizationId: parseInt(route.params.organizationId, 10),
          tab: 'organizationEvents',
        }),
      },
      {
        path: 'my',
        name: 'myOrganizationEvents',
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "organizationEventsTab" */ './views/subviews/events-organization-tab.vue'
            )
          ),
        props: (route) => ({
          organizationId: parseInt(route.params.organizationId, 10),
          tab: 'myOrganizationEvents',
        }),
      },
      {
        path: 'past',
        name: 'pastOrganizationEvents',
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "organizationEventsTab" */ './views/subviews/events-organization-tab.vue'
            )
          ),
        props: (route) => ({
          organizationId: parseInt(route.params.organizationId, 10),
          tab: 'pastOrganizationEvents',
        }),
      },
    ],
  },
]
